<template>
  <ReviewsResourcesBadges
    subject="agency"
    :entity-id="agency.id"
    :slug="agency.slug"
    :title="agency.title"
    :assigned-badges="agency.assignedBadges"
    :expired-assigned-badges="agency.expiredAssignedBadges"
    :is-fenced="!agency.configFlags.badgesManagementAllowed"
  />
</template>
<script setup lang="ts">
import type { AgencyData } from '@/gql/reviews'

import ReviewsResourcesBadges from '../../ReviewsCommon/Resources/ReviewsResourcesBadges.vue'

defineProps<{ agency: AgencyData }>()
</script>
